// mockup data exists pending the creation of a back-end with which we can interact

const employeeDatabase = [
  {
    id: 'BrunoCassouletHuman Ressources',
    firstName: 'Bruno',
    lastName: 'Cassoulet',
    dateOfBirth: '24/09/1988',
    startDate: '01/01/2001',
    street: '99 boulevard Bryas',
    city: 'Creil',
    state: 'Indiana',
    zipCode: '60100',
    department: 'Human Ressources',
  },
  {
    id: 'MartinMatinSales',
    firstName: 'Martin',
    lastName: 'Matin',
    dateOfBirth: '18/12/1999',
    startDate: '01/01/2001',
    street: '56 cours Franklin Roosevelt',
    city: 'Marseille',
    state: 'District of Columbia',
    zipCode: '13007',
    department: 'Sales',
  },
  {
    id: 'GérardDupaindurSales',
    firstName: 'Gérard',
    lastName: 'Dupaindur',
    dateOfBirth: '02/11/1989',
    startDate: '01/01/2001',
    street: '50 rue de Penthièvre',
    city: 'Privas',
    state: 'District of Columbia',
    zipCode: '07000',
    department: 'Sales',
  },
  {
    id: 'TupacKednouilleSales',
    firstName: 'Tupac',
    lastName: 'Kednouille',
    dateOfBirth: '02/04/1977',
    startDate: '01/01/2001',
    street: '6 rue de Geneve',
    city: 'Alfortville',
    state: 'District of Columbia',
    zipCode: '94140',
    department: 'Sales',
  },
]
export { employeeDatabase }
